<template>
  <fragment>
    <mc-app-header title="Order History">
      <template #left>
        <div class="level-item">
          <router-link
            class="button is-small is-primary is-outlined"
            to="/orders/new"
          >
            Add New
          </router-link>
        </div>
      </template>
      <template #right>
        <div class="level-item">
          <mc-user-select
            v-model="searchedUser"
            :filters="'master:true'"
            @input="searchInputHandler"
          />
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="orders section">
        <mc-paginated-list resource-state="orders">
          <div v-if="orders.list.length === 0" class="box mc-container">
            <div class="content has-text-centered">
              No orders available!
            </div>
          </div>
          <div v-else class="mc-container">
            <div
              v-for="(order, index) in orders.list"
              :key="index"
              class="orders__item box"
            >
              <div class="orders__item-desc" :set="(orderedUser = order.user)">
                <div class="orders__item-title">
                  {{ displayDetails(orderedUser) }}
                </div>
                <b-field grouped group-multiline>
                  <div class="control">
                    <b-taglist>
                      <b-tag :type="statusTagType(order.status)">{{
                        order.status
                      }}</b-tag>
                      <b-tag type="is-info">{{
                        order.plan.noOfClasses
                          ? `${order.plan.noOfClasses} classes`
                          : `${order.plan.timeLength} ${order.plan.timeUnit}`
                      }}</b-tag>
                      <b-tag type="is-info">{{
                        displayAmount(order.plan.amount)
                      }}</b-tag>
                    </b-taglist>
                  </div>
                  <div v-if="order.platform" class="control">
                    <b-taglist attached>
                      <b-tag type="is-dark">Platform</b-tag>
                      <b-tag type="is-info">
                        {{ order.platform }}
                      </b-tag>
                    </b-taglist>
                  </div>
                  <div class="control">
                    <b-taglist attached>
                      <b-tag type="is-dark">Create Time</b-tag>
                      <b-tag type="is-info">
                        {{ displayTimeFromTimestamp(order.createdAt) }}
                      </b-tag>
                    </b-taglist>
                  </div>
                </b-field>
              </div>
              <router-link
                v-if="order.status == 'completed'"
                disabled
                class="button is-link is-small"
                :to="`/orders/${order.id}`"
                >See Bill</router-link
              >
            </div>
          </div>
        </mc-paginated-list>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { displayAmount } from './utils';
import { displayDetails } from '../../utils/user';
import { displayTimeFromTimestamp } from '../../utils/time';

const statusTagTypes = {
  created: 'is-info',
  failed: 'is-danger',
  completed: 'is-success'
};

export default {
  data() {
    return {
      searchedUser: null
    };
  },
  computed: {
    ...mapState(['orders'])
  },
  methods: {
    ...mapActions('orders', ['addOrder', 'setFilter']),
    displayDetails,
    displayAmount,
    displayTimeFromTimestamp,
    statusTagType(status) {
      return statusTagTypes[status];
    },
    searchInputHandler(value) {
      this.setFilter({ user: value ? `/users/${value.objectID}` : null });
    }
  }
};
</script>

<style lang="scss" scoped>
.orders {
  height: 100%;

  &__item {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  &__item-desc {
    flex: 1 0 0;
  }

  &__item-title {
    margin-bottom: 0.5rem;
  }
}
</style>
